import React from "react";
import { Button } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import "./index.scss";
const ExportButton = ({ onClick }) => {
  return (
    <Button
      variant="light"
      onClick={onClick}
      className="d-flex align-items-center">
      <FaDownload className="me-1" /> Export
    </Button>
  );
};

export default ExportButton;
